import { useMemo } from "react"
import "./index.scss"
import { dynamicSortMultiple } from "utils/scripts/sort"
import { displaySampleId } from "utils/scripts/sampleId"
import { DateTime } from "luxon"
import Table from "react-bootstrap/Table"
import { useSelector } from "react-redux"
import useT from "utils/hooks/useT"

// A table displaying samples for printing format.
export default function SampleTableForPrinting({ popupSamples }) {
  const { t } = useT("common")
  // Sorting after three parameters. Depends on 'priorityMode'.
  const priorityMode = useSelector((state) => state.teamStatus.sortingParameter)
  const sortedPopupSamples = useMemo(
    () =>
      [...popupSamples].sort(
        dynamicSortMultiple(
          priorityMode === "DEADLINE" ? "deadline" : "priority",
          priorityMode === "DEADLINE" ? "priority" : "deadline",
          "sampleName"
        )
      ),
    [popupSamples, priorityMode]
  )
  const teamTimeZone = useSelector((state) => state.teamInfo.timezone)

  return (
    <Table bordered hover className="SampleTable">
      <thead>
        <tr>
          <th>{t("name")}</th>
          <th>{t("sampleId")}</th>
          <th>{t("productName")}</th>
          <th>{t("priority")}</th>
          <th>{t("arrival")}</th>
          <th>{t("deadline")}</th>
        </tr>
      </thead>
      <tbody>
        {sortedPopupSamples.map((sample) => (
          <tr
            key={sample.id}
            style={{
              fontStyle: sample.status === "FAILED" ? "italic" : "normal",
              fontWeight: sample.priority === 1 ? "bold" : "normal",
            }}
          >
            <td>{sample.sampleName}</td>
            {/* #4145 — DISPLAY. This sheet is printed and taken into the lab; a uuid on paper is
                worse than useless. FAILED rows are on it (they print in italics). */}
            <td>{displaySampleId(sample.observationId)}</td>
            <td>{sample.productName ? sample.productName : t("none")}</td>
            <td>{sample.priority}</td>
            <td className="sampletable-time-column">
              {DateTime.fromISO(sample.arrival).setZone(teamTimeZone).toFormat("ff")}
            </td>
            <td className="sampletable-time-column">
              {DateTime.fromISO(sample.deadline).setZone(teamTimeZone).toFormat("ff")}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
